import { render, staticRenderFns } from "./area.vue?vue&type=template&id=3c1c8dfe&scoped=true&"
import script from "./area.vue?vue&type=script&lang=js&"
export * from "./area.vue?vue&type=script&lang=js&"
import style0 from "./area.vue?vue&type=style&index=0&id=3c1c8dfe&lang=scss&scoped=true&"
import style1 from "./area.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c8dfe",
  null
  
)

export default component.exports